import React, { useState, useEffect } from "react";
import Card from "../../components/Card";
import Tabs from "../../components/Tabs";
import { NavLink, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import InnerHeader from "../../components/InnerHeader";
import { useTitle } from "../../hooks/useTitle";
import Settings from "./Settings";
import Courses from "./Courses";
import Billings from "./Billings";
import Document from "./Documents";

const MyAccount = () => {
  const navigate = useNavigate();
  const tabs = [
    { label: "Settings", value: "settings" },
    { label: "Courses", value: "course" },
    { label: "Documents", value: "documents" },
    { label: "Billing", value: "billing" },
  ];
  const [selectedTab, setSelectedTab] = useState("settings");
  const [nextActiveTab, setNextActiveTab] = useState("1");
  useTitle("My Account - Access Your Account - Flapone Aviation");

  const location = useLocation();
  const handleTabChange = (value) => {
    if(value=='settings'){
      navigate("/my-account?tab=settings")
    }else if(value=='course'){
      navigate("/my-account?tab=course")
    }else if(value=='documents'){
      navigate("/my-account?tab=documents")
    }else if(value=='billing'){
      navigate("/my-account?tab=billing")
    }
    //setSelectedTab(value);
  };
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const pathname = location.search;
    const tabParam = searchParams.get("tab");
    if (tabParam && tabs.some((tab) => tab.value === tabParam)) {
      setSelectedTab(tabParam);
    }else if (pathname === '?tab=Settings&section=newpass'){
      setSelectedTab("settings");
    }
    // eslint-disable-next-line
  }, [location.search]);

  return (
    <>
      <InnerHeader
        heading="My Account"
        txtSubHeading="Manage your account settings, courses, documents, and billing details all in one place."
        showButton={false}
        iconText="Add New Lead"
      />
      <Card className="account-conatiner bg1 mt16 p20 pb48">
        <Tabs
          tabs={tabs}
          showCheckboxes={false}
          showFilter={false}
          onTabChange={handleTabChange}
          selectedTab={selectedTab}
          nextActiveTab={nextActiveTab}
        />
        {selectedTab === "course" && <Courses />}
        {selectedTab === "settings" && <Settings />}
        {selectedTab === "billing" && <Billings />}
        {selectedTab === "documents" && <Document />}
      </Card>
    </>
  );
};

export default MyAccount;
